function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoldIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12 23.972656 C 18.628906 23.972656 24 18.703125 24 12.207031 C 24 5.710938 18.628906 0.441406 12 0.441406 C 5.371094 0.441406 0 5.710938 0 12.207031 C 0 18.703125 5.371094 23.972656 12 23.972656 Z M 12 23.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,55.29412%,18.82353%)",
      fillOpacity: 1
    },
    d: "M 9.617188 12.554688 L 14.964844 12.554688 C 15.132812 12.554688 15.292969 12.480469 15.390625 12.347656 C 15.492188 12.21875 15.527344 12.046875 15.480469 11.890625 L 14.410156 8.21875 C 14.34375 7.992188 14.132812 7.839844 13.894531 7.839844 L 10.6875 7.839844 C 10.449219 7.839844 10.238281 7.992188 10.171875 8.21875 L 9.105469 11.890625 C 9.058594 12.046875 9.089844 12.214844 9.191406 12.347656 C 9.292969 12.480469 9.449219 12.554688 9.617188 12.554688 Z M 11.144531 9.410156 L 12.367188 9.410156 L 11.910156 10.984375 L 10.6875 10.984375 Z M 11.144531 9.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,55.29412%,18.82353%)",
      fillOpacity: 1
    },
    d: "M 11.203125 13.460938 C 11.136719 13.234375 10.925781 13.082031 10.6875 13.082031 L 7.480469 13.082031 C 7.242188 13.082031 7.03125 13.234375 6.964844 13.460938 L 5.894531 17.128906 C 5.851562 17.289062 5.882812 17.457031 5.984375 17.589844 C 6.085938 17.722656 6.242188 17.796875 6.410156 17.796875 L 11.757812 17.796875 C 11.925781 17.796875 12.082031 17.722656 12.183594 17.589844 C 12.285156 17.457031 12.316406 17.289062 12.269531 17.128906 Z M 9.160156 16.226562 L 7.9375 16.226562 L 8.394531 14.652344 L 9.617188 14.652344 Z M 9.160156 16.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,55.29412%,18.82353%)",
      fillOpacity: 1
    },
    d: "M 18.6875 17.128906 L 17.617188 13.460938 C 17.550781 13.234375 17.34375 13.082031 17.105469 13.082031 L 13.894531 13.082031 C 13.65625 13.082031 13.445312 13.234375 13.382812 13.460938 L 12.3125 17.128906 C 12.265625 17.289062 12.296875 17.457031 12.398438 17.589844 C 12.5 17.722656 12.660156 17.796875 12.828125 17.796875 L 18.171875 17.796875 C 18.339844 17.796875 18.5 17.722656 18.601562 17.589844 C 18.703125 17.457031 18.734375 17.289062 18.6875 17.128906 Z M 15.652344 16.226562 L 14.429688 16.226562 L 14.890625 14.652344 L 16.113281 14.652344 Z M 15.652344 16.226562 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoldIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gold_icon.6296d81f.svg";
export { ForwardRef as ReactComponent };